import { Grid as ChakraGrid, type GridProps as ChakraGridProps } from '@chakra-ui/react'
import { forwardRef } from 'react'

export interface Props extends ChakraGridProps {}

export default forwardRef<HTMLDivElement, Props>((props, ref) => {
  return <ChakraGrid ref={ref} {...props} />
})